  <!-- KPI Cards -->
  <div class="kpi-grid">
    <article class="kpi-card" *ngFor="let card of summaryCards; trackBy: trackByIndex">
      <span class="kpi-label">{{ card.label }}</span>
      <div class="kpi-value">{{ card.value }}</div>
    </article>
  </div>

  <!-- NAMC Deployment Portfolio -->
  <article class="panel portfolio-panel">
    <div class="portfolio-header">
      <div>
        <h3 class="section-title">NAMC Deployment Portfolio</h3>
      </div>
      <div class="map-key">
        <span class="map-key-item"><i class="map-key-dot map-key-dot--enabled"></i> Enabled</span>
        <span class="map-key-item"><i class="map-key-dot map-key-dot--progress"></i> In Progress</span>
        <span class="map-key-item"><i class="map-key-dot map-key-dot--planned"></i> Planned</span>
      </div>
    </div>

    <div class="map-explorer">

      <!-- Map panel with real PNG background + positioned NAMC pins -->
      <div class="map-column">
      <div class="map-viewport" tabindex="0" role="region"
        aria-label="Scrollable North America deployment map">
      <div class="map-panel" role="group" aria-label="North America NAMC deployment map">
        <div class="map-info-box">
          <b>North America Deployment Footprint</b>
          <span>Select a NAMC to open its deployment metrics and shop enablement status.</span>
        </div>

        <!-- Zoom controls -->
        <div class="map-zoom-controls">
          <button type="button" class="map-zoom-btn" (click)="zoomIn()"
            [disabled]="mapZoom >= maxZoom" aria-label="Zoom in">+</button>
          <button type="button" class="map-zoom-btn" (click)="zoomOut()"
            [disabled]="mapZoom <= minZoom" aria-label="Zoom out">&minus;</button>
        </div>

        <!-- Zoomable layer: map image + positioned pins scale together -->
        <div class="map-zoom-layer" [style.transform]="'scale(' + mapZoom + ')'">
          <button *ngFor="let pin of deploymentMapPins; trackBy: trackByMapCode"
            class="namc-pin"
            [ngClass]="[
              'namc-pin--' + pin.status,
              isMapNamcSelected(pin.code) ? 'namc-pin--active' : ''
            ]"
            type="button"
            [style.left]="pin.left"
            [style.top]="pin.top"
            [style.--label-nudge]="pin.labelNudge"
            [style.--leader-len]="pin.leaderLen"
            [attr.aria-label]="getMapPinAriaLabel(pin)"
            [attr.aria-pressed]="isMapNamcSelected(pin.code)"
            (click)="selectMapNamc(pin)">
            <span class="pin-dot" aria-hidden="true"></span>
            <span class="pin-leader"
              [ngClass]="'pin-leader--' + pin.labelDirection"
              aria-hidden="true"></span>
            <span class="pin-label"
              [ngClass]="'pin-label--' + pin.labelDirection">{{ pin.code }}</span>
          </button>
        </div>

        <div class="map-bottom-legend">
          <span><i class="map-key-dot map-key-dot--enabled"></i> Enabled / Scaling</span>
          <span><i class="map-key-dot map-key-dot--progress"></i> In Progress</span>
          <span><i class="map-key-dot map-key-dot--planned"></i> Planned</span>
        </div>
      </div>
      </div>
      <p class="map-scroll-hint">Scroll horizontally to view the full map and select a NAMC.</p>
      </div>

      <!-- Deployment Detail Panel -->
      <div class="deployment-detail">
        <ng-container *ngIf="statusLoading; else detailReady">
          <div class="detail-title">{{ selectedPin ? selectedPin.code + ' Deployment Status' : 'Deployment Status' }}</div>
          <output class="detail-loading" aria-live="polite">
            <span class="detail-loading__spinner" aria-hidden="true"></span>
            <span class="detail-loading__text">Loading deployment status…</span>
          </output>
        </ng-container>
        <ng-template #detailReady>
          <ng-container *ngIf="selectedPin && selectedStatus as status; else detailEmpty">
            <div class="detail-title">{{ selectedPin.code }} Deployment Status</div>

            <div class="detail-stats">
              <div class="stat-chip"><b>{{ status.status.planned }}</b><span>Total Shops</span></div>
              <div class="stat-chip"><b>{{ status.status.enabled }}</b><span>Enabled</span></div>
              <div class="stat-chip"><b>{{ status.status.in_progress }}</b><span>In Progress</span></div>
              <div class="stat-chip"><b>{{ selectedMapRemaining }}</b><span>Planned (Not Started)</span></div>
            </div>
            <div class="detail-stats" style="margin-top: 8px">
              <div class="stat-chip stat-chip--wide"><b>{{ selectedMapCompletionPct | number: '1.0-1' }}%</b><span>Complete</span></div>
            </div>

            <div class="journey-progress-label">Deployment Journey Progress</div>
            <div class="mini-journey">
              <span *ngFor="let phase of deploymentPhases; trackBy: trackByPhaseNumber"
                class="mini-phase"
                [class.mini-phase--done]="isPhaseDone(phase.number)"
                [attr.title]="'Phase ' + phase.number + ': ' + phase.title"></span>
            </div>

            <h4 class="shops-title">Shop Enablement Status</h4>
            <div class="shop-enable-grid">
              <button *ngFor="let shop of status.shops; trackBy: trackByIndex"
                type="button"
                class="shop-enable-card"
                [class.shop-enable-card--selected]="isShopTileSelected(shop)"
                [class.shop-enable-card--enabled]="shop.status === 'enabled'"
                [class.shop-enable-card--progress]="shop.status === 'progress'"
                (click)="selectShopTile(shop)">
                <div class="shop-name">{{ shop.name }}</div>
                <div class="shop-status" [class.shop-status--progress]="shop.status === 'progress'">{{ shop.status === 'progress' ? 'IN PROGRESS' : (shop.status | uppercase) }}</div>
              </button>
            </div>
          </ng-container>
          <ng-template #detailEmpty>
            <div class="detail-title">Deployment Status</div>
            <p class="muted">Select a NAMC on the map to view its deployment metrics and shop enablement status.</p>
          </ng-template>
        </ng-template>
      </div>

    </div>

    <!-- Deployment Journey Track -->
    <div class="journey-section" aria-label="EDC deployment journey">
      <div class="journey-track">
        <div *ngFor="let phase of deploymentPhases; trackBy: trackByPhaseNumber"
          class="journey-step"
          [class.journey-step--done]="isPhaseDone(phase.number)"
          [class.journey-step--active]="isPhaseCurrent(phase.number)"
          [style.--step-color]="phase.color">
          <div class="step-num">{{ phase.number }}</div>
          <span>{{ phase.title }}</span>
          <span *ngIf="isPhaseDone(phase.number)" class="step-check" aria-hidden="true">✓</span>
        </div>
      </div>
      <div class="journey-caption">
        <span>Standard deployment lifecycle — completed phases are checked and the selected NAMC's current phase is emphasized.</span>
      </div>
    </div>
  </article>

  <!-- NAMC Deployment Progress & Milestones -->
  <article class="panel">
    <div class="section-head-row">
      <div>
        <h3 class="section-title">NAMC Deployment Progress &amp; Milestones</h3>
      </div>
      <div class="filter-pair">
        <label class="select-control">
          NAMC
          <select [(ngModel)]="selectedMilestoneNamc"
                  (ngModelChange)="onMilestoneNamcFilterChange($event)"
                  aria-label="Filter by NAMC">
            <option value="ALL">All NAMCs</option>
            <option *ngFor="let row of milestoneRows" [value]="row.plant">{{ row.plant }}</option>
          </select>
        </label>
        <label class="select-control">
          Shop Type
          <select [(ngModel)]="selectedMilestoneShopType" aria-label="Filter by shop type">
            <option value="ALL">All Shop Types</option>
            <option value="Assembly">Assembly</option>
            <option value="Body Weld">Body Weld</option>
            <option value="Paint">Paint</option>
            <option value="Plastics">Plastics</option>
            <option value="Stamping">Stamping</option>
            <option value="Casting">Casting</option>
            <option value="Other">Other</option>
          </select>
        </label>
      </div>
    </div>
    <div class="table-wrap">
      <table class="data-table">
        <thead>
          <tr>
            <th>NAMC / Plant</th>
            <th class="numeric">Total Shops</th>
            <th class="numeric">Enabled</th>
            <th class="numeric">In Progress</th>
            <th class="numeric">Planned</th>
            <th class="numeric">Completion</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let row of filteredMilestoneRows; trackBy: trackByPlant">
            <!-- NAMC parent row -->
            <tr class="namc-row" (click)="toggleMilestoneNamc(row.plant)">
              <td>
                <span class="expand-chevron" [class.expand-chevron--open]="isMilestoneNamcExpanded(row.plant)">&#9656;</span>
                <strong>{{ row.plant }}</strong>
              </td>
              <td class="numeric">{{ row.loaded ? row.totalShops : '—' }}</td>
              <td class="numeric">{{ row.loaded ? row.completed : '—' }}</td>
              <td class="numeric">{{ row.loaded ? row.inProgress : '—' }}</td>
              <td class="numeric">{{ row.loaded ? (row.totalShops - row.completed - row.inProgress) : '—' }}</td>
              <td class="numeric">
                <span *ngIf="row.loaded" class="completion-pill"
                  [class.pill--good]="row.completionPct >= 75"
                  [class.pill--warn]="row.completionPct >= 60 && row.completionPct < 75"
                  [class.pill--bad]="row.completionPct < 60">
                  {{ row.completionPct }}%
                </span>
                <span *ngIf="!row.loaded">—</span>
              </td>
            </tr>
            <!-- Shop child rows -->
            <ng-container *ngIf="isMilestoneNamcExpanded(row.plant)">
              <tr class="shop-row" *ngFor="let shop of getMilestoneShopRows(row.plant); trackBy: trackByIndex">
                <td class="shop-name-cell"><span class="shop-indent"></span><span class="shop-name-text" [title]="shop.name">{{ shop.name }}</span></td>
                <td class="numeric">1</td>
                <td class="numeric">{{ shop.status === 'enabled' ? 1 : 0 }}</td>
                <td class="numeric">{{ shop.status === 'progress' ? 1 : 0 }}</td>
                <td class="numeric">{{ shop.status === 'planned' ? 1 : 0 }}</td>
                <td class="numeric">
                  <span class="completion-pill"
                    [class.pill--good]="shopStatusCompletion(shop.status) >= 75"
                    [class.pill--warn]="shopStatusCompletion(shop.status) >= 50 && shopStatusCompletion(shop.status) < 75"
                    [class.pill--bad]="shopStatusCompletion(shop.status) < 50">
                    {{ shopStatusCompletion(shop.status) }}%
                  </span>
                </td>
              </tr>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="milestoneRows.length === 0">
            <tr><td><strong>TABC</strong></td><td class="numeric">45</td><td class="numeric">37</td><td class="numeric">5</td><td class="numeric">3</td><td class="numeric"><span class="completion-pill pill--good">82.2%</span></td></tr>
            <tr><td><strong>TMMC</strong></td><td class="numeric">82</td><td class="numeric">62</td><td class="numeric">12</td><td class="numeric">8</td><td class="numeric"><span class="completion-pill pill--good">75.6%</span></td></tr>
            <tr><td><strong>TMMI</strong></td><td class="numeric">8</td><td class="numeric">5</td><td class="numeric">2</td><td class="numeric">1</td><td class="numeric"><span class="completion-pill pill--warn">62.5%</span></td></tr>
            <tr><td><strong>TMMK</strong></td><td class="numeric">12</td><td class="numeric">9</td><td class="numeric">2</td><td class="numeric">1</td><td class="numeric"><span class="completion-pill pill--good">75.0%</span></td></tr>
            <tr><td><strong>TMMTX</strong></td><td class="numeric">10</td><td class="numeric">7</td><td class="numeric">2</td><td class="numeric">1</td><td class="numeric"><span class="completion-pill pill--warn">70.0%</span></td></tr>
            <tr><td><strong>TMMMS</strong></td><td class="numeric">9</td><td class="numeric">6</td><td class="numeric">2</td><td class="numeric">1</td><td class="numeric"><span class="completion-pill pill--warn">66.7%</span></td></tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </article>
